import { combineReducers } from 'redux';
import { AuditLogTypes } from '../../action_types';

function ui(state = [], action) {
  switch (action.type) {
    case AuditLogTypes.GET_AUDIT_LOGS_BY_SUPERUSER_SUCCESS:
    case AuditLogTypes.GET_AUDIT_LOGS_BY_ORG_ADMIN_SUCCESS:  
      return action.data.results
    default:
      return state
  }
}

function meta(state = {}, action) {
  switch (action.type) {
    case AuditLogTypes.GET_AUDIT_LOGS_BY_SUPERUSER_SUCCESS: 
    case AuditLogTypes.GET_AUDIT_LOGS_BY_ORG_ADMIN_SUCCESS:  
      {
        const { results, ...rest } = action.data
        return { ...state, ...rest }
      }
    default:
      return state
  }
}


export default combineReducers({ ui, meta });
